import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const RedditReportsNoRowsOverlay: FC = () => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col gap-[32px] text-gray-700 items-center justify-center h-full w-full">
			<div className="text-[18px]">
				{t('There are no statistics for the selected time range and data sources', 'There are no statistics for the selected time range and data sources')}
			</div>
		</div>
	);
};

export default RedditReportsNoRowsOverlay;
